export default __webpack_public_path__ + "static/tractor-7d41a971c210a135bf332ac994d4bbab.gif";